import { render, staticRenderFns } from "./NewAcquisitionDocumentPage.vue?vue&type=template&id=4006b30d&scoped=true"
import script from "./NewAcquisitionDocumentPage.vue?vue&type=script&lang=js"
export * from "./NewAcquisitionDocumentPage.vue?vue&type=script&lang=js"
import style0 from "./NewAcquisitionDocumentPage.vue?vue&type=style&index=0&id=4006b30d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4006b30d",
  null
  
)

export default component.exports